module.exports = __webpack_public_path__ + "img/5e2d121d7b032776a5a35e4019033e0f.7cf65fa2.jpg";